<template>
  <v-card>
    <v-form @submit.prevent="prevent" v-model="valid" autocomplete="off">
      <v-card-title class="text-h5">Change Type</v-card-title>
      
      <v-card-text>
        <v-text-field variant="underlined" readonly :rules="nameRules" label="Name" required :model-value="changeType.type.value" auto-grow></v-text-field>
        <v-row>
          <v-col cols="4">
            <label>Default</label>
            <v-switch
              class="ml-2"
              :error-messages="defaultRules()"
              :error="typeof defaultRules() === 'string'"
              v-model="changeType.default_"
              :label="changeType.default_ ? 'On' : 'Off'"
              :readonly="readonly"
            ></v-switch>
          </v-col>
          <v-col cols="4" v-if="changeType.type.key !== permanentChangeType">
            <label>Enabled</label>
            <v-switch
              v-model="changeType.enabled"
              :readonly="readonly"
              :label="changeType.enabled ? 'Yes' : 'No'"
              :disabled="disableEnable"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row v-if="changeType.type.key !== permanentChangeType">
          <v-col cols="12">
            <v-text-field
              type="number"
              variant="underlined"
              label="Number of Days before each unauthorized expired escalation"
              v-model="changeType.daysInterval"
              min="0"
              :readonly="readonly"
              :rules="validateDaysInterval"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <TaskPicker
              :tasks="tasks"              
              @selectTask="selectTask"
              @deleteTask="deleteSelectedTask"
              :selectedTasks="changeType.tasks"
              @onClick="onTaskClick"
              :readonly="readonly"
              @addTask="onTaskAdd"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="!readonly" :disabled="!valid" color="success" @click="save">Save</v-btn>
        <v-btn @click="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import TaskPicker from '@/components/TaskPicker'
import { ChangeTypes } from '@/common/types'
import MOCService from '@/services/moc.service'

export default {
  name: 'ChangeTypeForm',
  data: () => ({
    minimumNameLength: 0,
    maximumNameLength: 120,
    valid: false,
    mocCount: 0,
    daysInterval: 5
  }),
  methods: {
    prevent() {
      return true
    },
    save() {
      this.$emit('submit', this.changeType)
    },
    closeDialog() {
      this.$emit('close')
    },
    defaultRules() {
      return this.changeType.default_ &&
        this.existingChangeTypes.findIndex(x => x.default_ && x.clientID !== this.changeType.clientID) > 0
        ? 'There is already a default change type'
        : null
    },
    selectTask(task) {
      if (!task) return
      this.changeType.tasks = (this.changeType.tasks || []).filter(t => t !== task.clientID).concat(task.clientID)
    },
    deleteSelectedTask(task) {
      this.changeType.tasks = this.changeType.tasks.filter(t => t !== task.clientID)
    },
    onTaskClick(task) {
      this.$emit('onTaskClick', task)
    },
    onTaskAdd(search) {
      this.$emit('onTaskAdd', search, this.selectTask)
    },
    getMocCount() {
      return new Promise((resolve, reject) => {
        MOCService.getMocCount(this.shortName).then(c => {
          resolve((this.mocCount = c))
        })
      })
    }
  },
  computed: {
    nameRules: {
      get: function() {
        return [
          v => !!v || 'Name is required',
          v => (v && v.trim().length > this.minimumNameLength) || `Minimum length is ${this.minimumNameLength}`,
          v => (v && v.trim().length < this.maximumNameLength) || `Maximum length is ${this.maximumNameLength}`,
          v =>
            this.existingChangeTypes.findIndex(x => x.type.key.trim() === v.trim() && x.clientID !== this.changeType.clientID) <
              0 || 'Name already exists!'
        ]
      }
    },
    permanentChangeType: function() {
      return ChangeTypes.properties[ChangeTypes.PERMANENT].key
    },
    disableEnable() {
      return this.mocCount > 0 ? true : false
    },
    validateDaysInterval() {
      return [() => (this.daysInterval < 0 ? 'This field cannot be less than zero' : true)]
    }
  },
  props: {
    changeType: Object,
    existingChangeTypes: Array,
    tasks: Array,
    shortName: {
      type: String,
      default: null
    },
    readonly: Boolean
  },
  components: {
    TaskPicker
  },
  beforeMount() {
    if (this.shortName) {
      this.getMocCount()
    }
  }
}
</script>
<style></style>
